import { render, staticRenderFns } from "./ThemePicker.vue?vue&type=template&id=53dd780c&"
import script from "./ThemePicker.vue?vue&type=script&lang=js&"
export * from "./ThemePicker.vue?vue&type=script&lang=js&"
import style0 from "./ThemePicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\YrtDev\\wms\\wms-site\\main\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53dd780c')) {
      api.createRecord('53dd780c', component.options)
    } else {
      api.reload('53dd780c', component.options)
    }
    module.hot.accept("./ThemePicker.vue?vue&type=template&id=53dd780c&", function () {
      api.rerender('53dd780c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/components/ThemePicker.vue"
export default component.exports